import PhotoSwipe from './index.vue';

export default PhotoSwipe;



// WEBPACK FOOTER //
// ../src/ui/photo-swipe/index.js